import React, { useState } from "react";
import {
  RootContainer,
  Logo,
  Form,
  BackIcon,
  NavContainer,
} from "./ForgotPassword.style";
import { Button, Input } from "antd";
import { api } from "@api";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { RESET_MODE_SK } from "@constants";
import { useDispatch } from "react-redux";
import { openAlert } from "@redux/app/appSlice";
import { Alert } from "@components";
import { useTranslation } from "react-i18next";

const ForgotPassword = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onFinish = ({ phone }) => {
    if (!loading) {
      setLoading(true);
      api
        .forgotPassword({ phone })
        .then((response) => {
          setLoading(false);
          showAlert({
            message: response?.message,
            successCallback: () => successCallback(phone),
          });
        })
        .catch((errorMsg) => {
          setLoading(false);
          showAlert({
            message: errorMsg,
            isError: true,
          });
        });
    }
  };

  const successCallback = (phone) => {
    navigate(`/${PUBLIC_ROUTE.OTP_VERIFY}/${RESET_MODE_SK}`, {
      state: { phone },
    });
  };

  const showAlert = (data) => {
    dispatch(openAlert(data));
  };

  const goBack = () => {
    navigate(-1);
  };

  return (
    <>
      <RootContainer>
        <NavContainer>
          <BackIcon onClick={goBack} />
        </NavContainer>
        <Logo />
        <Form layout="vertical" requiredMark={false} onFinish={onFinish}>
          <Form.Item
            name="phone"
            label={t("auth.forgotPasswordPhone")}
            rules={[
              {
                required: true,
                message: "",
              },
              {
                pattern: /^0(1|9)\d{7,9}$/,
                message: t("auth.forgotPasswordPhoneValidate"),
              },
            ]}
          >
            <Input autoFocus type="number" size="large" placeholder="09*********" />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              loading={loading}
            >
              {t("common.continue")}
            </Button>
          </Form.Item>
        </Form>
      </RootContainer>
      <Alert />
    </>
  );
};

export default ForgotPassword;
